/**
 * Blouse Stitching Add-On — Production JavaScript
 * Chiffon Banaras | Vanilla JS | No jQuery | No external libs
 */

(function () {
  'use strict';

  const section = document.querySelector('.blouse-stitching-section');
  if (!section) return;

  const sectionId          = section.dataset.sectionId;
  const stitchingVariantId = section.dataset.stitchingVariantId;
  const stitchingPrice     = parseInt(section.dataset.stitchingPrice, 10) || 0;

  const toggle          = section.querySelector('.bs-toggle-checkbox');
  const fields          = section.querySelector(`#bs-fields-${sectionId}`);
  const customMeasDiv   = section.querySelector(`#bs-custom-measurements-${sectionId}`);
  const customTextarea  = section.querySelector(`#bs-measurements-${sectionId}`);
  const productPriceEl  = section.querySelector(`#bs-product-price-${sectionId}`);
  const totalPriceEl    = section.querySelector(`#bs-total-price-${sectionId}`);

  const sizeError         = section.querySelector(`#bs-size-error-${sectionId}`);
  const paddingError      = section.querySelector(`#bs-padding-error-${sectionId}`);
  const openingError      = section.querySelector(`#bs-opening-error-${sectionId}`);
  const measurementsError = section.querySelector(`#bs-measurements-error-${sectionId}`);

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '\u20b9' + Number(amount).toLocaleString('en-IN');
  }

  function getProductPrice() {
    const productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        const selectedVariantInput = document.querySelector('[name="id"]:checked, [name="id"]');
        if (selectedVariantInput && data.variants) {
          const variantId = parseInt(selectedVariantInput.value, 10);
          const variant = data.variants.find(v => v.id === variantId);
          if (variant) return variant.price;
        }
        return data.price || 0;
      } catch (e) {}
    }
    const priceEl = document.querySelector(
      '.price__regular .price-item--regular, .product__price .price, [data-product-price]'
    );
    if (priceEl) {
      const text = priceEl.textContent.replace(/[^\d]/g, '');
      const num = parseInt(text, 10);
      return num > 10000 ? num : num * 100;
    }
    return 0;
  }

  function updatePriceSummary() {
    if (!productPriceEl || !totalPriceEl) return;
    const productPrice = getProductPrice();
    productPriceEl.textContent = formatMoney(productPrice);
    totalPriceEl.textContent   = formatMoney(productPrice + stitchingPrice);
  }

  function onToggleChange() {
    const checked = toggle.checked;
    toggle.setAttribute('aria-expanded', checked ? 'true' : 'false');
    if (checked) {
      fields.removeAttribute('hidden');
      fields.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        fields.style.gridTemplateRows = '1fr';
        fields.style.visibility = 'visible';
      });
      updatePriceSummary();
    } else {
      fields.style.gridTemplateRows = '0fr';
      fields.style.visibility = 'hidden';
      fields.setAttribute('aria-hidden', 'true');
      fields.addEventListener('transitionend', function handler() {
        if (!toggle.checked) fields.setAttribute('hidden', '');
        fields.removeEventListener('transitionend', handler);
      });
      clearErrors();
    }
  }

  function onSizeChange(e) {
    if (!customMeasDiv) return;
    if (e.target.classList.contains('bs-custom-size-trigger') && e.target.checked) {
      customMeasDiv.removeAttribute('hidden');
      customMeasDiv.style.gridTemplateRows = '1fr';
      customMeasDiv.style.visibility = 'visible';
    } else if (!e.target.classList.contains('bs-custom-size-trigger')) {
      customMeasDiv.style.gridTemplateRows = '0fr';
      customMeasDiv.style.visibility = 'hidden';
      customMeasDiv.addEventListener('transitionend', function handler() {
        customMeasDiv.setAttribute('hidden', '');
        customMeasDiv.removeEventListener('transitionend', handler);
      });
    }
    if (sizeError) sizeError.setAttribute('hidden', '');
  }

  function clearErrors() {
    [sizeError, paddingError, openingError, measurementsError].forEach(el => {
      if (el) el.setAttribute('hidden', '');
    });
  }

  function validate() {
    let valid = true;
    clearErrors();
    const size = section.querySelector(`[name="bs-size-${sectionId}"]:checked`);
    if (!size) {
      if (sizeError) sizeError.removeAttribute('hidden');
      valid = false;
    }
    if (size && size.classList.contains('bs-custom-size-trigger')) {
      if (!customTextarea || !customTextarea.value.trim()) {
        if (measurementsError) measurementsError.removeAttribute('hidden');
        valid = false;
      }
    }
    const padding = section.querySelector(`[name="bs-padding-${sectionId}"]:checked`);
    if (!padding) {
      if (paddingError) paddingError.removeAttribute('hidden');
      valid = false;
    }
    const opening = section.querySelector(`[name="bs-opening-${sectionId}"]:checked`);
    if (!opening) {
      if (openingError) openingError.removeAttribute('hidden');
      valid = false;
    }
    return valid;
  }

  function interceptAddToCart() {
    const productForm = document.querySelector(
      'form[action="/cart/add"], [data-type="add-to-cart-form"]'
    ) || document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    productForm.addEventListener('submit', function (e) {
      if (!toggle.checked) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!validate()) return;
      addBothToCart(productForm);
    }, true);
  }

  function getStitchingProperties(productTitle, productHandle) {
    const size    = section.querySelector(`[name="bs-size-${sectionId}"]:checked`);
    const padding = section.querySelector(`[name="bs-padding-${sectionId}"]:checked`);
    const opening = section.querySelector(`[name="bs-opening-${sectionId}"]:checked`);
    const measurements = customTextarea ? customTextarea.value.trim() : '';
    const props = {
      'Blouse Stitching': 'Yes',
      'Size': size ? size.value : '',
      'Padding': padding ? padding.value : '',
      'Opening Type': opening ? opening.value : '',
      'Product Name': productTitle || document.title,
      'Product Handle': productHandle || window.location.pathname
    };
    if (measurements) props['Custom Measurements'] = measurements;
    return props;
  }

  function getMainVariantId(form) {
    const variantInput = form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  async function addBothToCart(form) {
    if (!stitchingVariantId) {
      console.warn('[BlouseStitching] No stitching variant ID configured.');
      return;
    }
    const mainVariantId = getMainVariantId(form);
    if (!mainVariantId) {
      console.warn('[BlouseStitching] Could not find main product variant ID.');
      return;
    }
    let productTitle = '';
    let productHandle = '';
    try {
      const metaEl = document.querySelector('[data-product-json]');
      if (metaEl) {
        const data = JSON.parse(metaEl.textContent);
        productTitle  = data.title || '';
        productHandle = data.handle || '';
      }
    } catch (e) {}
    const stitchingProps = getStitchingProperties(productTitle, productHandle);
    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    const submitBtn = form.querySelector('[type="submit"], [name="add"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(mainVariantId, 10), quantity: quantity },
            { id: parseInt(stitchingVariantId, 10), quantity: quantity, properties: stitchingProps }
          ]
        })
      });
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Cart error');
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const cartDrawerTrigger = document.querySelector('[data-cart-drawer-toggle], #cart-icon-bubble');
      if (cartDrawerTrigger) cartDrawerTrigger.click();
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('shopify:cart:updated'));
    } catch (error) {
      console.error('[BlouseStitching] Add to cart failed:', error);
      alert('Sorry, there was an error adding to cart. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      }
    }
  }

  function onVariantChange() {
    if (toggle.checked) updatePriceSummary();
  }

  if (toggle) toggle.addEventListener('change', onToggleChange);

  section.addEventListener('change', function (e) {
    if (e.target.name === `bs-size-${sectionId}`) onSizeChange(e);
    if (e.target.name === `bs-padding-${sectionId}` || e.target.name === `bs-opening-${sectionId}`) {
      const errId = e.target.name.includes('padding')
        ? `bs-padding-error-${sectionId}`
        : `bs-opening-error-${sectionId}`;
      const errEl = section.querySelector(`#${errId}`);
      if (errEl) errEl.setAttribute('hidden', '');
    }
  });

  document.addEventListener('variant:changed', onVariantChange);
  document.addEventListener('variantChange', onVariantChange);

  interceptAddToCart();

})();